export default __webpack_public_path__ + "static/image-testimonials-grid-f53349bfb020bb1efa51c3f6134c7c31.png";